import { render, staticRenderFns } from "./OrderPullAutomation.vue?vue&type=template&id=32c7b135&scoped=true"
import script from "./OrderPullAutomation.vue?vue&type=script&lang=js"
export * from "./OrderPullAutomation.vue?vue&type=script&lang=js"
import style0 from "./OrderPullAutomation.vue?vue&type=style&index=0&id=32c7b135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c7b135",
  null
  
)

export default component.exports